import { Component, computed, input, output } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';

import { BaasHierarchicalAction } from '../baas-hierarchical-action.type';
import { BaasHierarchicalActionConfig, createDefaultBaasHierarchicalActionConfig } from '../baas-hierarchical-action-config.type';
import { BaasHierarchicalListItemMoveConfig } from '../baas-hierarchical-list-item-move-config.type';

@Component({
    selector: 'baas-hierarchical-list-item',
    templateUrl: './baas-hierarchical-list-item.html',
    imports: [MatBadgeModule, MatButtonModule, MatIconModule, MatMenuModule, MatTooltipModule]
})
export class BaasHierarchicalListItem {
    readonly item = input.required<any>();
    readonly actionConfig = input<BaasHierarchicalActionConfig>(createDefaultBaasHierarchicalActionConfig());
    readonly itemLabelField = input('title');
    readonly itemIdField = input('id');
    readonly itemTooltipField = input('tooltip');
    readonly moveEnabled = input(false);
    readonly moveConfig = input<BaasHierarchicalListItemMoveConfig>();
    readonly itemClickActionType = input<BaasHierarchicalAction>('edit');
    readonly itemClickHideAction = input(false);
    readonly action = output<BaasHierarchicalAction>();

    protected readonly enableItemClick = computed(() => {
        const type = this.item().itemClickActionType ? this.item().itemClickActionType : this.itemClickActionType();
        const globalActive = this.actionConfig()[type];
        const itemTypeNotSet = this.item()[type] === undefined;
        const itemTypeActive = this.item()[type] !== undefined && this.item()[type];

        return (globalActive && itemTypeNotSet) || itemTypeActive;
    });

    protected readonly optionMenuEnabled = computed(() => {
        return this.actionEnabled('create') || this.actionEnabled('edit') || this.actionEnabled('delete') || this.actionEnabled('move');
    });

    protected doAction(actionType: BaasHierarchicalAction): void {
        this.action.emit(actionType);
    }

    protected actionEnabled(type: string): boolean {
        const globalActive = this.actionConfig()[type];
        const itemTypeNotSet = this.item()[type] === undefined;
        const itemTypeActive = this.item()[type] !== undefined && this.item()[type];
        const itemClickActionTypeActive =
            this.item().itemClickActionType === type || (this.itemClickActionType() === type && this.item().itemClickActionType === undefined);
        // active on the item itself or global active and NOT disabled on item
        // AND
        // clickAction is current type and not set to hidden
        return (
            ((globalActive && itemTypeNotSet) || itemTypeActive) && ((itemClickActionTypeActive && !this.itemClickHideAction()) || !itemClickActionTypeActive)
        );
    }
}
